/**
 * Admin 认证 API：login / me / menus / refresh / logout
 * 镜像 customer 契约；admin 无作用域 id（无 register / cardholderId）。
 *
 * FE-E2b 薄壳化：五件套模板（login/logout/refresh/me/menus）下沉
 * @shared/api/auth 工厂；本文件保留端配置与类型，导出面不变（调用方零改动）。
 */
import {
  adminGet,
  adminPost,
  clearSession,
  loadSession,
  saveSession,
  signOutLocal,
  USE_MOCK,
  type AdminSession,
  type PortalSessionView,
} from './client';
import { createAuthApi, type TokenPair } from '@shared/api/auth';

const auth = createAuthApi<AdminSession, PortalSessionView>({
  get: adminGet,
  post: adminPost,
  loadSession,
  saveSession,
  clearSession,
  signOutLocal,
  // Admin 特有 mock 身份：无作用域 id，守卫标志从会话回读
  mockMe: () => {
    const s = loadSession();
    return {
      subjectId: 0,
      channel: 'ADMIN',
      principal: s?.principal || 'admin@mock',
      roles: ['ADMIN'],
      permissions: [],
      mustChangePassword: s?.me?.mustChangePassword === true,
      mfaSetupRequired: s?.me?.mfaSetupRequired === true,
      otpGraceRemainingSeconds: s?.me?.otpGraceRemainingSeconds ?? 0,
    };
  },
  // 登录基础会话（admin 无作用域 id）
  buildSession: (t: TokenPair, principal: string): AdminSession => ({
    accessToken: t.accessToken,
    refreshToken: t.refreshToken,
    principal,
    expiresAt: t.expiresIn ? Date.now() + t.expiresIn * 1000 : undefined,
  }),
  // 并行 me/menus 合并：失败置 null 不回滚（admin 无作用域 id 回写）
  mergeAfterLogin: (current, meRes, menusRes) => ({
    ...current,
    me: meRes.ok ? meRes.data : null,
    menus: menusRes.ok ? menusRes.data : null,
  }),
});

export const { fetchMe, refreshSessionMe, fetchMenus, refreshTokens, logout, login, logoutLocal } = auth;

export type { TokenPair };

export { USE_MOCK };
